import { UEListData } from "@/app/interface/homepage";
import React from "react";
interface BalanceSheet {
  filteredData: UEListData
}

type BalanceSheetItem ={
  
    title: string;
    values: string[];
};
const BalanceSheet: React.FC<BalanceSheet> = ({ filteredData }) => {
  console.log(filteredData)
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm text-left border-collapse">
        <thead>
          <tr className="heading-row">
            <th className="pr-4 py-2 font-medium text-xs text-gray-500 border-b-2 border-black">
              (In Rs. Crore)
            </th>
            {filteredData?.companyFinancials?.fiscalYears?.map(
              (item: string, index: number) => (
                <th key={index} className="px-4 py-3 font-medium text-xs text-gray-500 border-b-2 border-black">
                  {item}
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody>
          {filteredData?.companyFinancials?.data?.map(
            (item: BalanceSheetItem, index: number) => (
              <tr key={index}>
                <td className="pr-4 py-3 text-sm font-medium text-black border-b">
                  {item.title}
                </td>
                {item.values.map((value: string, id: number) => (
                  <td key={id} className="px-4 py-3 font-medium text-sm text-gray-700 border-b">
                    {value}
                  </td>
                ))}
              </tr>
            )
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BalanceSheet;
